// 关闭类型
export const CLOSE_TYPES = {
  null: {
    label: '', // 进行中
    value: null,
  },
  1: {
    label: '主动关闭',
    value: 1,
  },
  2: {
    label: '网约合作商关闭',
    value: 2,
  },
  3: {
    label: '到期关闭',
    value: 3,
  },
}

// 共享状态
export const SHARE_STATUS = {
  0: {
    label: '已关闭',
    value: 0,
  },
  1: {
    label: '进行中',
    value: 1,
  },
  2: {
    label: '待确认',
    value: 2,
  },
  3: {
    label: '等待共享',
    value: 3,
  },
}
